import { render, staticRenderFns } from "./FlagSelection.vue?vue&type=template&id=0c28b3b5&"
import script from "./FlagSelection.vue?vue&type=script&lang=js&"
export * from "./FlagSelection.vue?vue&type=script&lang=js&"
import style0 from "./FlagSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VCombobox,VIcon,VListItem,VListItemAction,VListItemContent,VListItemIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c28b3b5')) {
      api.createRecord('0c28b3b5', component.options)
    } else {
      api.reload('0c28b3b5', component.options)
    }
    module.hot.accept("./FlagSelection.vue?vue&type=template&id=0c28b3b5&", function () {
      api.rerender('0c28b3b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scheduling/FlagSelection.vue"
export default component.exports